import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useT } from "@/i18n/LanguageContext";

export const ConfirmDialog = ({ open, onClose, onConfirm, title, message, confirmLabel, danger = true }) => {
  const { t } = useT();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="confirm-dialog">
        <DialogTitle className="sr-only">{title || t("Are you sure?")}</DialogTitle>
        <DialogDescription className="sr-only">{message}</DialogDescription>
        <div className="flex items-start gap-3">
          {danger && <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0"><AlertTriangle className="w-5 h-5 text-red-500" /></div>}
          <div className="min-w-0">
            <h3 className="text-base font-semibold text-slate-900">{title || t("Are you sure?")}</h3>
            {message && <p className="text-sm text-slate-500 mt-1">{message}</p>}
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <Button variant="outline" className="flex-1" onClick={onClose} data-testid="confirm-cancel">{t("Cancel")}</Button>
          <Button
            className={`flex-1 ${danger ? "bg-red-600 hover:bg-red-700 text-white" : ""}`}
            onClick={onConfirm}
            data-testid="confirm-action"
          >
            {confirmLabel || t("Delete")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
